import { render, staticRenderFns } from "./RevezamentoInscrevase.vue?vue&type=template&id=0f0c949c&scoped=true&"
import script from "./RevezamentoInscrevase.vue?vue&type=script&lang=js&"
export * from "./RevezamentoInscrevase.vue?vue&type=script&lang=js&"
import style0 from "./RevezamentoInscrevase.vue?vue&type=style&index=0&id=0f0c949c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c949c",
  null
  
)

export default component.exports